const vimeoOverlay = document.getElementById('vimeoModalOverlay');
  const vimeoIframe = document.getElementById('vimeoModalIframe');
  const vimeoClose = document.getElementById('vimeoModalClose');

  // Play button click
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-card-play-btn');
    if (!btn) return;

    const videoUrl = btn.dataset.videoUrl;
    if (!videoUrl) return;

    // Vimeo ID nikalo
    const vimeoId = videoUrl.match(/vimeo\.com\/(\d+)/)?.[1];
    if (!vimeoId) return;

    // Iframe me src set karo autoplay ke saath
    vimeoIframe.src = 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&title=0&byline=0&portrait=0';

    // Modal open karo
    vimeoOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  // Close button click
  vimeoClose.addEventListener('click', function () {
    vimeoOverlay.classList.remove('active');
    vimeoIframe.src = '';
    document.body.style.overflow = '';
  });

  // Backdrop click se close
  vimeoOverlay.addEventListener('click', function (e) {
    if (e.target === vimeoOverlay) {
      vimeoOverlay.classList.remove('active');
      vimeoIframe.src = '';
      document.body.style.overflow = '';
    }
  });

  // ESC key se close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      vimeoOverlay.classList.remove('active');
      vimeoIframe.src = '';
      document.body.style.overflow = '';
    }
  });